import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ServiceInformationService } from './services/service-information.service';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { MeetingRoomComponent } from '../meeting-room/meeting-room.component';

@Component({
  selector: 'app-service-information',
  templateUrl: './service-information.component.html',
  styleUrls: ['./service-information.component.scss']
})
export class ServiceInformationComponent implements OnInit {
  @ViewChild(MeetingRoomComponent, { static: false }) meetingRoomComponent!: MeetingRoomComponent;
  @Input() openFormServiceInformation!: boolean;
  @Input() appointmentId?: string = '';
  @Input() protocol?: string = '';

  formServiceInformation!: UntypedFormGroup;

  constructor(
    private readonly toastService: ToastService,
    private readonly serviceInformationService: ServiceInformationService,
  ) { }

  ngOnInit(): void {
    this.openFormServiceInformation = sessionStorage.getItem('openFormServiceInformation') === 'true';
    this.appointmentId = sessionStorage.getItem('appointmentId')!;
    this.protocol = sessionStorage.getItem('protocol')!;

    this.formServiceInformation = new UntypedFormGroup({
      protocol: new UntypedFormControl({ value: this.protocol, disabled: true }),
      status: new UntypedFormControl('', [Validators.required]),
      observation: new UntypedFormControl(''),
      externalProtocol: new UntypedFormControl('')
    });

    sessionStorage.removeItem('openFormServiceInformation');
    sessionStorage.removeItem('appointmentId');
    sessionStorage.removeItem('protocol');

  }

  public saveServiceInformation(): void {
    if (this.formServiceInformation.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.formServiceInformation.markAllAsTouched();
      return;
    }

    if (this.formServiceInformation.valid) {
      this.serviceInformationService.addServiceInformation(this.appointmentId!, this.formServiceInformation.value).subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast(resposta.messages);
        }

        if (resposta.isSucceed) {
          this.toastService.toast('Formulário enviado com sucesso!')
          this.openFormServiceInformation = false;
        }
      });
    }
  }
}